import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        width: '100dvw',
        flexDirection: 'column',
        gap: '20px',
    },
    buttonContainer: {
        display: 'flex',
        gap: '20px',
    },
    loadingContainer: {
        width: '75%',
    },
}));
